






















import type { PropType } from '@vue/composition-api';
import { defineComponent } from '@vue/composition-api';
import type { Currency } from '@getaccept/lib-shared/src/types/Currency';
import { DashboardWidgetHeaderColor } from '../../../types/enums/dashboard-widget-header-color';
import DashboardWidgetList from '../../DashboardWidgetList.vue';
import DashboardEmptyStateText from '../../DashboardEmptyStateText.vue';
import type { DashboardPerformer } from '../../../types/dashboard-performer';
import TopPerformersWidgetItem from './TopPerformersWidgetItem.vue';

export default defineComponent({
  name: 'TopPerformersWidget',
  components: {
    DashboardWidgetList,
    TopPerformersWidgetItem,
    DashboardEmptyStateText,
  },
  props: {
    performers: {
      type: Array as PropType<DashboardPerformer[]>,
      default: null,
    },
    currency: {
      type: Object as PropType<Currency>,
      default: null,
    },
  },
  setup(props) {
    const topValue = props.performers[0]?.value || 0;

    return {
      topValue,
      DashboardWidgetHeaderColor,
    };
  },
});
